<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            md="6"
                            offset-md="3"
                    >
                        <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Reset password') }}</h1>
                        <v-card
                                class="mx-auto form-card"
                                outlined
                        >

                            <v-card-text class="text--primary">
                                <ValidationObserver ref="observer">
                                    <v-form autocomplete="off" v-model="valid" @submit.prevent="requestResetPassword">

                                        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="email"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Email')"
                                                    required
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-form>
                                </ValidationObserver>
                                <div class="d-flex justify-end">
                                    <v-btn tile elevation="0" color="primary" @click="requestResetPassword">{{ $t('buttons.Submit') }}</v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>
    import axios from "axios";
    import { store } from '../store';

    import { extend } from 'vee-validate';
    import { required, email } from 'vee-validate/dist/rules';

    import Footer from './Footer'
    import {i18n} from "../i18n";
    import {mapState} from "vuex";

    extend('required', required);
    extend('email', email);

    export default {
        name: "ForgotPassword",
        components: {
            'Footer': Footer
        },
        metaInfo () {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('Request Reset Password'),
            htmlAttrs: {
              lang: i18n.locale
            }
          }
        },
        data() {
            return {
                email: null,
                has_error: false,
                valid: false
            }
        },
        mounted () {
            this.$gtag.pageview({
                page_path: '/reset-password'
            })
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            async requestResetPassword() {

                let observer = this.$refs.observer;

                const isValid = await observer.validate();

                if (isValid) {
                    let apiClient = axios.create({
                        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                        headers: {'Accept-Language': i18n.locale},
                        withCredentials: false,
                    });

                    return apiClient
                        .post('/forgot-password', {
                            email: this.email
                        })
                        .then(response => {
                            console.log(response.data);
                            store.dispatch('alert/success', 'Please check your email', { root: true });
                        })
                        .catch(function (error) {
                            console.error(error);
                            // Add the server side errors for each field.
                            if (error.response.status === 422) {

                                // store server side validation errors
                                return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                                    observer.setErrors(store.getters.validationErrors);
                                });

                            }

                        });

                }
            }
        }
    }
</script>

<style scoped>

</style>
